import { useQuery } from "react-query";
import { getAlarmsByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useAlarmsByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetAlarmsByRecordNumber", recNumber],
    () => getAlarmsByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
